import { Link } from "react-router-dom";
import { fruitBaskets, images, shakeProducts } from "../data";
import {
  PageHeader,
  PrimaryButton,
  ProductCard,
  SectionTitle,
} from "../components/UI";

import "../css/Products.css";
import { useEffect } from "react";
export default function Products({ type = "shake" }) {
  const isFruit = type === "fruit";
  const products = isFruit ? fruitBaskets : shakeProducts;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrap container-xl">
      <PageHeader
        eyebrow={isFruit ? "Market fresh" : "Natural nutrition"}
        title={
          isFruit
            ? "Fresh fruits, delivered on schedule"
            : "Fresh protein shakes"
        }
        copy={
          isFruit
            ? "Choose a basket and tell us when you want it."
            : "Natural ingredients, prepared fresh for your scheduled delivery."
        }
      />

      {isFruit ? (
        <div className="market-banner">
          <img src={images.market} alt="Fruit market" />
          <div>
            <span className="eyebrow">Freshness loop</span>
            <h2>You schedule → we buy → we pack → we deliver</h2>
          </div>
        </div>
      ) : (
        <div className="service-intro">
          <div>
            <span className="eyebrow">For busy gym-goers</span>
            <h2>Your protein, on schedule.</h2>
            <p>Choose a shake once and schedule it daily or weekly.</p>
          </div>
          <Link to="/fruits" className="btn btn-soft">
            See fresh fruits <i className="fa-solid fa-arrow-right ms-2" />
          </Link>
        </div>
      )}

      <SectionTitle title={isFruit ? "Choose a basket" : "Choose your shake"} />
      <div className="row g-4">
        {products.map((product) => (
          <div className="col-12 col-md-6 col-xl-4" key={product.id}>
            <ProductCard product={product} />
          </div>
        ))}
      </div>

      {isFruit && (
        <div className="build-basket">
          <div>
            <span className="eyebrow">More control</span>
            <h2>Build my basket</h2>
          </div>
          <PrimaryButton to="/fruits/small-fruit-basket">
            Start building
          </PrimaryButton>
        </div>
      )}
    </div>
  );
}
